import { render, staticRenderFns } from "./DiagramLegend.vue?vue&type=template&id=2f141a21&scoped=true&"
import script from "./DiagramLegend.vue?vue&type=script&lang=js&"
export * from "./DiagramLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f141a21",
  null
  
)

export default component.exports